<template>
  <v-sheet class="grey pagination-container lighten-2 pa-1 rounded-lg">
    <v-btn
      icon
      small
      @click="$emit('jumpToPage',1)"
    >
      <v-icon>mdi-page-first</v-icon>
    </v-btn>
    <v-btn
      icon
      small
      @click="$emit('prevPage')"
    >
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    <v-menu
      offset-y
      max-width="45"
      bottom
    >
      <template #activator="{on,attrs}">
        <v-btn
          v-bind="attrs"
          small
          color="white"
          :ripple="false"
          class="px-2"

          v-on="on"
        >
          {{ currentPage }}
          <v-icon x-small> mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <div class="white">
        <v-virtual-scroll
          :items="pagesAsArrayC"
          item-height="35"
          max-height="203"
          :bench="6"
        >
          <template #default="{item}">
            <v-list-item
              class="mx-auto"
              @click="$emit('jumpToPage',item)"
            >
              <small>{{ item }}</small>
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </div>
    </v-menu>
    <v-btn
      icon
      small
      @click="$emit('nextPage')"
    >
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
    <v-btn
      icon
      small
      @click="$emit('jumpToPage',totalPages)"
    >
      <v-icon>mdi-page-last</v-icon>
    </v-btn>
  </v-sheet>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 1
    }
  },
  emits: ['jumpToPage', 'prevPage', 'nextPage'],
  data() {
    return {
      pagesAsArray: []
    }
  },

  computed: {
    pagesAsArrayC() {
      return Array.from({ length: this.totalPages }, (k, v) => v + 1)
    }
  },
  mounted() {
    this.pagesAsArray = Array.from({ length: this.totalPages }, (k, v) => v + 1)
  }

}
</script>

<style scoped>
::-webkit-scrollbar {
  display: none;
}
.pagination-container{
    -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  width: fit-content;
}
.v-menu__content {
    box-shadow: -4px 27px 94px rgba(73, 73, 73, 0.404);
}
</style>
